function Product() {
  return (
    <main className="sec-content sec-content_3">
      <div className="container-def">
        <div className="sec-content__wrap">
          <div className="product-info">
            <div className="product-info__top">
              <div className="product-info__top-left">
                <div className="product-info__title title-def title-def_sec2">Силиконовая резина специального назначения</div>
                <div className="product-info__title title-def title-def_sec3">Изоляторная</div>
              </div>
              <div className="img-dec">
                <img src={window.location.origin+"/img/10.webp"} alt="" className="img-dec__img" />
              </div>
            </div>
            <div className="product-info__content wrap-article-2">
              <h4>Описание</h4>
              <p>Силиконовая резиновая смесь для производства высоковольтных изоляторов.<br/>Применяется для изготовления изделий методами формования, литья под давлением или экструзии. Рекомендуется для производства высоковольтных изоляторов, оболочек кабелей и кабельных аксессуаров.</p>
              <p></p>
              <h4>Основные характеристики</h4>
              <a target="_blank" href={window.location.origin+"/products/silikonovye-reziny/rezina-izolyatornaya/Rutesil-T161-2.pdf"} download>Rutesil® T 161/2</a>
              <br/>
              <a target="_blank" href={window.location.origin+"/products/silikonovye-reziny/rezina-izolyatornaya/Rutesil-T261-2.pdf"} download>Rutesil® T 261/2</a>
              <br/>
              <a target="_blank" href={window.location.origin+"/products/silikonovye-reziny/rezina-izolyatornaya/Rutesil-T271-2.pdf"} download>Rutesil® T 271/2</a>
              <p></p>
              <h4>Упаковка</h4>
              <p>Гофрокартон, 20 кг.</p>
              <p></p>
              <h4>Хранение</h4>
              <p>Хранить в защищенном от атмосферных воздействий, сухом месте. Гарантийный срок хранения – 12 месяцев с даты производства (информация дана на этикетке или в сертификате качества для каждой партии). По истечении периода продукт может быть использован после повторной проверки свойств.</p>
              <p></p>
              <h4>Указания по безопасности</h4>
              <p>Продукт стабилен и не опасен при нормальных условиях.</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
export default Product;